import { useEffect, useState } from "react";

interface MoneyInputProps {
  value: number;
  onChange: (n: number) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  /** Esconde o prefixo "R$" (default: mostra) */
  semPrefixo?: boolean;
}

/**
 * Input monetário em R$ — formata enquanto digita (1234,56 → R$ 1.234,56),
 * sem zero à esquerda nem setas de incremento.
 *
 * Internamente armazena o valor em centavos (inteiro) pra evitar problemas de float.
 */
export function MoneyInput({ value, onChange, placeholder = "0,00", className, disabled, autoFocus, semPrefixo }: MoneyInputProps) {
  const [texto, setTexto] = useState<string>(formatar(value));

  useEffect(() => {
    setTexto(formatar(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    // só dígitos
    const digits = e.target.value.replace(/\D/g, "");
    const cents = digits ? parseInt(digits, 10) : 0;
    setTexto(formatar(cents / 100));
    onChange(cents / 100);
  }

  function handleFocus(e: React.FocusEvent<HTMLInputElement>) {
    // Seleciona tudo no foco para facilitar substituir
    e.target.select();
  }

  return (
    <div className={`relative ${className || ""}`}>
      {!semPrefixo && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm pointer-events-none">R$</span>
      )}
      <input
        type="text"
        inputMode="numeric"
        value={texto}
        onChange={handleChange}
        onFocus={handleFocus}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        className={`w-full ${semPrefixo ? "pl-3" : "pl-10"} pr-3 py-2 rounded-lg border border-slate-300 outline-none text-sm focus:border-blue-500 ${disabled ? "bg-slate-100 cursor-not-allowed" : ""}`}
      />
    </div>
  );
}

function formatar(n: number): string {
  if (!n || n === 0) return "";
  return n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
